import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useTranslations } from 'next-intl';

interface UpvoteIndicatorProps extends Omit<BoxT, 'translate'> {
  upvotes: number;
  isTopVoted: boolean;
  upvotesFontSize?: number | string;
}

export const UpvoteIndicator = ({
  upvotes,
  isTopVoted,
  upvotesFontSize = 6,
  ...rest
}: UpvoteIndicatorProps) => {
  const translate = useTranslations('presenting.legacy');

  const upvotesLabel =
    upvotes === 1 ? translate('message.vote') : translate('message.votes');

  return (
    <Box
      flexDirection="row"
      justifyContent="space-between"
      width="100%"
      alignItems="center"
      data-testid="upvotes-indicator"
      {...rest}
    >
      <Text
        fontWeight="semiBold"
        fontSize={upvotesFontSize}
        color="text"
        aria-label={`${upvotes} ${upvotesLabel}`}
      >
        {upvotes}
      </Text>

      {isTopVoted && (
        <Box bg="primary" borderRadius={3} px={3} py={2}>
          <Text color="onPrimary" fontSize={3} fontWeight="semiBold">
            {translate('message.top_voted')}
          </Text>
        </Box>
      )}
    </Box>
  );
};
